import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "pt-4 border-b border-gray-200"
};
const _hoisted_3 = {
  key: 1
};
import { storeToRefs } from 'pinia';
import { computed, onMounted, reactive } from 'vue';
import LlTabs from '@/components/LlTabs.vue';
import InvoiceEmail from './InvoiceEmail.vue';
import InvoicePdf from './InvoicePdf/InvoiceTemplate/InvoicePdf.vue';
import InvoiceSummary from './InvoicePdf/OtherPages/InvoiceSummary.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import SnackbarComponent from '@/components/SnackbarComponent.vue';
export default {
  __name: 'InvoiceHeaderPage',
  props: {
    leanLawApi: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      getMe
    } = useMeStore();
    const {
      features
    } = storeToRefs(useMeStore());
    const props = __props;
    const headerState = reactive({
      templateOptions: [{
        name: 'Invoice Template',
        icon: 'mdi-note-text-outline',
        active: true,
        value: 'invoiceTemplate'
      }, {
        name: 'Email Settings',
        icon: 'mdi-email-outline',
        active: false,
        value: 'emailSettings'
      }]
    });
    onMounted(async () => {
      await getMe();
      if (features.value.invoiceSummaryPage || features.value.settlementV2) {
        headerState.templateOptions.splice(1, 0, {
          name: 'Other Pages',
          icon: 'mdi-file-document-outline',
          active: false,
          value: 'otherPages'
        });
      }
    });
    const templateTabs = computed(() => headerState.templateOptions.map(option => ({
      value: option.value,
      label: option.name,
      icon: option.icon
    })));
    const activeTemplateOption = computed(() => headerState.templateOptions.find(option => option.active)?.value);
    const selectTemplateOption = value => {
      headerState.templateOptions.forEach(option => {
        option.active = option.value === value;
      });
    };
    const activeComponent = computed(() => {
      const activeOption = headerState.templateOptions.find(option => option.active);
      switch (activeOption?.value) {
        case 'invoiceTemplate':
          return InvoicePdf;
        case 'otherPages':
          return InvoiceSummary;
        case 'emailSettings':
          return InvoiceEmail;
        default:
          return null;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(SnackbarComponent, {
        ref: "snackbar"
      }, null, 512), _unref(features).leanlawInvoice ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LlTabs, {
        "model-value": activeTemplateOption.value,
        items: templateTabs.value,
        "onUpdate:modelValue": selectTemplateOption
      }, null, 8, ["model-value", "items"])]), (_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(activeComponent.value), {
        userService: __props.userService,
        leanLawApi: __props.leanLawApi,
        state: __props.state,
        alerts: __props.alerts,
        rootScope: __props.rootScope,
        tracking: __props.tracking,
        leanLawAuth: __props.leanLawAuth
      }, null, 8, ["userService", "leanLawApi", "state", "alerts", "rootScope", "tracking", "leanLawAuth"]))], 1024))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(InvoiceEmail, {
        userService: __props.userService,
        rootScope: __props.rootScope,
        tracking: __props.tracking,
        state: __props.state,
        alerts: __props.alerts,
        leanLawAuth: __props.leanLawAuth
      }, null, 8, ["userService", "rootScope", "tracking", "state", "alerts", "leanLawAuth"])]))], 64);
    };
  }
};